<template>
  <div class="auth-page__wrapper">
    <div class="auth-page">
      <div class="auth-page__body">
        <div class="h1">Send Login Link</div>

        <div class="intro-text">
          Please specify your email address. If an account exists by that email,
          we will send you a link to log in to the site.
        </div>
        <v-form @submit.prevent="sendLoginLink">
          <v-layout style="margin: 0 -12px" wrap>
            <v-flex xs12 class="pa-3">
              <v-text-field
                label="Email*"
                v-model="form.email"
                type="email"
              ></v-text-field>
            </v-flex>
            <v-flex xs12></v-flex>
            <v-flex xs12 class="pa-3">
              <v-layout justify-space-between align-center>
                <v-btn color="red" @click="sendLoginLink"
                  >Send Login Link</v-btn
                >
              </v-layout>
            </v-flex>
          </v-layout>
        </v-form>

        <Recaptcha />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {}
    };
  },
  mounted() {
    //this.checkToken();
    this.$gtag.event("PageVisit", {
      event_category: "page_visit",
      event_label: "PageVisit",
      value: "send login link"
    });
  },
  methods: {
    async checkToken() {
      const { reset_token } = this.$route.params;
      await this.$recaptchaLoaded();
      const recaptcha = await this.$recaptcha("login");
      try {
        await this.$api.Auth.checkResetToken({ recaptcha, reset_token });
      } catch {
        this.$router.push("/");
      }
    },
    async sendLoginLink() {
      this.form.recaptcha = await this.$recaptcha("login");
      await this.$api.User.sendLoginLink(this.form);
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
.auth-page__body {
  max-width: 560px;
  margin: 0 auto;
  padding: 0 30px;
}
</style>
